import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

export const Loader = (props: Omit<CustomFontAwesomeIconProps, 'spin'>) => {
  return (
    <FontAwesomeIcon
      icon={['fasr', 'loader']}
      spin
      {...props}
    />
  );
};
